
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiComRadio as ObiComRadioElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-com-radio.js';
 
 
 

 
 export const ObiComRadio = createComponent({
   react: React,
   tagName: 'obi-com-radio',
   elementClass: ObiComRadioElement,
   events: {
     
   }
  });
 
 